import WorkspaceHeaderTabs from '../molecules/WorkspaceHeaderTabs';
import {
  MotifButton,
  MotifCard,
  MotifCardBody,
  MotifCardHeader,
  MotifIcon,
  MotifProgressLoader
} from '@ey-xd/motif-react';
import React, { useCallback, useEffect } from 'react';
import iconSvg from '../../assets/icons/icon.svg.json';
import WorkspaceCard from '../atoms/WorkspaceCard';
import WorkspaceSearchAndFilter from '../molecules/WorkspaceSearchAndFilter';
import WorkspacesList from '../molecules/WorkspacesList';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const menus = ['My workspaces', 'Recommended workspaces'];
const Workspaces = () => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [workspaces, setWorkspaces] = React.useState<any>();
  const [search, setSearch] = React.useState('');
  const [subdomain, setSubdomain] = React.useState();
  const { access } = useSelector((state: any) => state.user);

  const navigate = useNavigate();
  const { myWorkspaces } = useSelector((state: any) => state.workspaces);
  const dispatch = useDispatch();

  useEffect(() => {
    const { read } = access;
    if (read) {
      dispatch(
        {
          type: 'GET_WORKSPACES'
        },
        {}
      );
    }
  }, [access]);

  useEffect(() => {
    setWorkspaces(myWorkspaces);
  }, [myWorkspaces]);
  const renderWorkspaces = useCallback(() => {
    if (!workspaces)
      return (
        <div>
          <p>Loading...</p>
        </div>
      );
    return <WorkspacesList workspaces={workspaces} />;
  }, [workspaces]);

  const triggerSearch = () => {
    const filteredWithSubdomain = !subdomain
      ? myWorkspaces
      : myWorkspaces?.filter((wksp: any) => {
        if (subdomain) {
          if (wksp.type === subdomain) {
            return wksp;
          }
        } else {
          return wksp;
        }
      });
    let searched =
      search === ''
        ? filteredWithSubdomain
        : filteredWithSubdomain?.filter((wksp: any) => {
          if (
            wksp.name.toLowerCase().includes(search.toLowerCase()) ||
            wksp.oppurtunityId.toLowerCase().includes(search.toLowerCase())
          ) {
            return wksp;
          }
        });
    setWorkspaces(searched);
  };
  useEffect(() => {
    triggerSearch();
  }, [search, subdomain]);

  return (
    <div className="flex flex-col min-h-full m-3">
      <MotifCard className="min-h-[50vh] !bg-[transparent]">
        <MotifCardHeader className="!py-0" style={{ borderBottom: '1px solid #ffffff26' }}>
          <div className="flex gap-10 items-center !justify-between !w-full">
            <WorkspaceHeaderTabs menus={menus} active={activeTab} setActive={setActiveTab} />
            <div>
              {access.write === true && (
              <MotifButton
                onClick={() => {
                  navigate('/');
                }}
                size="small"
                className="!rounded-none !h-[30px] inline"
              >
                + Create new
              </MotifButton>
              )}
            </div>
          </div>
        </MotifCardHeader>
        <MotifCardBody className="!min-h-80">
          <WorkspaceSearchAndFilter
            subdomain={subdomain}
            setSubdomain={setSubdomain}
            search={search}
            setSearch={setSearch}
          />
          {access.read === false ? (
            <p className="text-center font-bold">Read access denied</p>
          ) : (
            <>
              {workspaces && !workspaces.length ? (
                <div className="motif-row justify-content-center">
                  <div className="motif-col-8 flex items-center">
                    <h2>No records found!!!</h2>
                  </div>
                </div>
              ) : (
                renderWorkspaces()
              )}
            </>
          )}
        </MotifCardBody>
      </MotifCard>
    </div>
  );
};

export default Workspaces;
